import { LessVisitsImg } from '../../../../../images';

export default function OwnYourSmile() {
  
  return (
    <div className="relative h-screen ">
      <div className="h-1/2 lg:h-full w-full pt-16 md:pt-20 lg:pt-0 flex flex-col justify-center text-center  lg:w-1/2 lg:text-left ">
        <div className="z-10 px-4 max-w-2xl mx-auto sm:px-8">
          <h1 className="text-center lg:text-left text-primary text-2xl sm:text-3xl lg:text-4xl font-semibold">Less visits and more affordable treatments</h1>
          <p className="mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
            <h2 className="text-center lg:text-left text-xl font-sans text-lpGray my-2">Thanks to our proprietary AI technology.</h2>
            <div className='my-2 mx-auto lg:mx-0 lg:my-4 w-32 border border-primary'/>
            <p className="text-center lg:text-left text-gray-500 my-1">A combination of 30 years of experience in refined aesthetics, newly dedicated to our full digital process and an economy of scale brings you this promise.</p>
            <p className="text-center lg:text-left text-gray-500 my-1">Let us help you transform your smile.</p>
          </p>
        </div>
        </div>
        <div className="relative h-2/3 lg:absolute lg:inset-y-0 lg:right-0 lg:w-full lg:h-full z-0">
          <img
            className="absolute inset-0 pb-32 lg:pb-0 object-cover w-full h-full"
            src={LessVisitsImg}
            alt=""
          />
        </div>
    </div>
  )
}
